// src/components/common/LegalPageLayout.tsx

import React from 'react';

interface LegalPageLayoutProps {
    title: string;
    children: React.ReactNode;
}

export function LegalPageLayout({ title, children }: LegalPageLayoutProps) {
    return (
        <div className="bg-card-bg">
            <div className="container mx-auto max-w-4xl px-4 py-12">
                <h1 className="text-4xl font-extrabold text-text-primary border-b border-border-color pb-4 mb-8">
                    {title}
                </h1>
                <div className="space-y-6 text-text-secondary leading-relaxed">
                    {children}
                </div>
            </div>
        </div>
    );
}